module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/6-d566716e9755d13c1bcd9560d0162bd8.jpg";